import { dataActual, MASCARA_ISO_DIA, textAMoment } from "../../utils/dates";
import {
  INICIALITZAR,
  INTRODUCCIO_OMPLIR_DATA
} from "../../actions/actionTypes";

const ESTAT_INICIAL = dataActual().format(MASCARA_ISO_DIA);

const data = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case INTRODUCCIO_OMPLIR_DATA:
      return action.payload.format(MASCARA_ISO_DIA);

    default:
      return state;
  }
};

export default data;

export const getData = state => state;
export const getDataAsMoment = state => textAMoment(state, MASCARA_ISO_DIA);
